var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import stylesContacts from '../Contacts/Contacts.module.scss';
import stylesSettings from '../Settings/Settings.module.scss';
import InputComponent from "../../InputComponent/InputComponent";
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import { setChat } from "../../store/slices/setChatIDSlice";
import { closeMenu, setClearGlobalSearchUser, setTempChat } from "../../store/slices/appSlice";
import RemoveFromChannelIcon from '../../assets/person-dash.svg';
import UserInfo from "../MenuComponent/UserInfo";
import { channelAPI, messagesAPI, profileAPI } from "../../API/api";
import { createObjectChannel } from "../../utils/utils";
import DialogComponent, { ConfirmComponent } from "../Settings/DialogComponent";
import DescriptionComponent from "../Settings/DescriptionComponent";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import { Virtuoso } from "react-virtuoso";
import Preloader from '../../assets/preloader.svg';
import ShareChatButton from "./ShareChatButton";
import { clickType } from "../../constants/constants";
var ModalAction;
(function (ModalAction) {
    ModalAction["DELETE_CHANNEL"] = "DELETE_CHANNEL";
    ModalAction["AVAILABILITY_CHANNEL"] = "AVAILABILITY_CHANNEL";
    ModalAction["SHOW_SUBSCRIBERS_LIST"] = "SHOW_SUBSCRIBERS_LIST";
    ModalAction["CLEAR_MESSAGES"] = "CLEAR_MESSAGES";
})(ModalAction || (ModalAction = {}));
const SubscriberItem = ({ initialUser, currentUser, ownerUid, handleClickName, removeFromChannel }) => {
    const [userData, setUserData] = useState(initialUser);
    const isOwner = ownerUid === initialUser.uid;
    useEffect(() => {
        let isMounted = true;
        const fetchFreshData = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const userInfo = yield profileAPI.getCurrentInfo(initialUser.uid);
                if (isMounted && userInfo) {
                    console.log('Получены обновлённые данные');
                    setUserData(Object.assign({}, userInfo));
                }
            }
            catch (error) {
                console.error(`Не удалось получить данные пользователя ${initialUser.uid}`, error);
            }
        });
        fetchFreshData();
        return () => { isMounted = false; };
    }, [initialUser.uid]);
    return (_jsxs("li", { style: { margin: '4px 8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }, onClick: () => handleClickName(userData), children: [_jsx("span", { style: { fontSize: '1.1rem', margin: '2px 0px' }, children: userData.displayName }), _jsxs("div", { style: { display: 'flex', alignItems: 'center' }, children: [isOwner && (_jsx("span", { className: stylesContacts.indicationAdmin, children: "admin" })), !isOwner && currentUser.uid === ownerUid && (_jsx("div", { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0438\u0437 \u043A\u0430\u043D\u0430\u043B\u0430", style: { cursor: 'pointer', marginLeft: '8px' }, onClick: (e) => removeFromChannel(e, userData), children: _jsx(RemoveFromChannelIcon, { fontSize: '1.2rem' }) }))] })] }));
};
const ListSubscribers = ({ channel, currentUser, isOwner }) => {
    var _a;
    const [name, setName] = useState('');
    const dispatch = useAppDispatch();
    const filteredList = useMemo(() => {
        var _a, _b;
        return (_b = (_a = channel.listOfSubscribers) === null || _a === void 0 ? void 0 : _a.filter(item => item.displayName.toLowerCase().includes(name.toLowerCase()))) !== null && _b !== void 0 ? _b : [];
    }, [channel.listOfSubscribers, name]);
    const handleClickName = (user) => {
        if (user.uid === currentUser.uid)
            return;
        dispatch(closeMenu(null));
        dispatch(setTempChat(user));
    };
    const removeFromChannel = (e, subscriber) => {
        e.stopPropagation();
        channelAPI.changeListSubscribers(clickType.REMOVE_FROM_LIST_SUBSCRIBERS, channel.channelID, subscriber);
    };
    return (_jsxs("div", { style: { flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', marginBottom: '4px', height: '100%' }, children: [_jsx(InputComponent, { classes: stylesContacts.item, returnValue: setName }), _jsx("ul", { className: stylesContacts.list, style: { display: 'flex', flexDirection: 'column', overflow: 'auto', marginBottom: '4px' }, children: !((_a = channel.listOfSubscribers) === null || _a === void 0 ? void 0 : _a.length) ? (_jsx("span", { children: "\u0423\u0447\u0430\u0441\u043D\u0438\u043A\u0438 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B" })) : (_jsx(Virtuoso, { style: { height: '100%' }, data: filteredList, totalCount: filteredList.length, itemContent: (index, item) => (_jsx(SubscriberItem, { initialUser: item, currentUser: currentUser, ownerUid: channel.owner.uid, handleClickName: handleClickName, removeFromChannel: removeFromChannel }, item.uid)) })) })] }));
};
const ChannelFullInfoComponent = () => {
    const [modalState, setModalState] = useState({ isOpen: false, value: null });
    const [deletingMessages, setDeletingMessages] = useState(false);
    const dispatch = useAppDispatch();
    const channel = useAppSelector(state => state.app.selectedChannel || state.app.selectedChat.channel);
    const currentUser = useAppSelector(state => state.app.currentUser);
    const { t } = useTypedTranslation();
    const isOwner = currentUser.uid === channel.owner.uid;
    const textAccessButoon = channel.isOpen ? `${t('closeСhannel')}` : `${t('openChannel')}`;
    const changeStateModal = (state) => {
        setModalState(prev => (Object.assign(Object.assign({}, prev), { isOpen: state })));
    };
    const handleClick = () => {
        if (channel.owner.uid !== currentUser.uid) {
            dispatch(setClearGlobalSearchUser(true));
            dispatch(closeMenu(null));
            dispatch(setTempChat(channel.owner));
        }
    };
    const deleteChannel = () => {
        channelAPI.deleteChannel(channel.channelID)
            .then(() => {
            //setIsOpenDialog(false)
            changeStateModal(false);
            dispatch(closeMenu());
            dispatch(setChat(null));
        });
    };
    const clearAllMessages = () => {
        setDeletingMessages(true);
        const toChat = createObjectChannel(channel);
        messagesAPI.clearChat(toChat, false)
            .then(() => changeStateModal(false))
            .finally(() => setDeletingMessages(false));
    };
    const changeAccessChannel = () => __awaiter(void 0, void 0, void 0, function* () {
        yield channelAPI.changeAccessChannel(channel.channelID, !channel.isOpen);
        changeStateModal(false);
    });
    const targetComponent = () => {
        if (modalState.value === ModalAction.DELETE_CHANNEL)
            return _jsx(ConfirmComponent, { confirmFunc: deleteChannel, text: t('areYouSure?') });
        if (modalState.value === ModalAction.AVAILABILITY_CHANNEL)
            return _jsx(ConfirmComponent, { confirmFunc: changeAccessChannel, text: textAccessButoon });
        if (modalState.value === ModalAction.SHOW_SUBSCRIBERS_LIST)
            return _jsx(ListSubscribers, { channel: channel, currentUser: currentUser, isOwner: isOwner });
        if (modalState.value === ModalAction.CLEAR_MESSAGES)
            return _jsx(ConfirmComponent, { confirmFunc: clearAllMessages, text: `${t('clearMessages')} ?` });
        return null;
    };
    const description = [
        { title: t('owner'), description: channel.owner.displayName, onClick: handleClick },
        { title: t('created'), description: channel.registrationDate.toString() },
    ];
    return (_jsx("div", { style: { display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }, children: _jsxs("div", { style: { overflow: 'auto' }, children: [_jsx("div", { children: _jsxs("div", { className: stylesSettings.settings, children: [_jsx(UserInfo, { isSettings: isOwner, currentInfo: Object.assign(Object.assign({}, currentUser), { channel }) }), _jsx("hr", { className: stylesSettings.hr })] }) }), _jsx("div", { className: stylesContacts.item, children: _jsx(DescriptionComponent, { items: description }) }), _jsx("div", { className: stylesContacts.item, children: _jsx(ShareChatButton, { chat: createObjectChannel(channel) }) }), _jsx("hr", { className: stylesSettings.hr }), isOwner &&
                    _jsxs(_Fragment, { children: [_jsx("div", { className: stylesContacts.item, children: _jsxs("div", { style: { display: 'flex', flexWrap: 'wrap', gap: '8px' }, children: [_jsx("button", { onClick: () => setModalState({ isOpen: true, value: ModalAction.AVAILABILITY_CHANNEL }), children: textAccessButoon }), _jsx("button", { onClick: () => setModalState({ isOpen: true, value: ModalAction.DELETE_CHANNEL }), children: t('removeChannel') }), _jsx("button", { onClick: () => setModalState({ isOpen: true, value: ModalAction.CLEAR_MESSAGES }), style: { minWidth: 100 }, children: deletingMessages ? _jsx(Preloader, {}) : t('clearMessages') })] }) }), _jsx("hr", { className: stylesSettings.hr })] }), _jsx("div", { className: stylesContacts.item, children: _jsx("button", { onClick: () => setModalState({ isOpen: true, value: ModalAction.SHOW_SUBSCRIBERS_LIST }), children: t('showSubscribers') }) }), modalState.isOpen &&
                    _jsx(DialogComponent, { isOpen: modalState.isOpen, onClose: changeStateModal, children: targetComponent() })] }) }));
};
export default ChannelFullInfoComponent;
